import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  Button,
  ModalView,
  Dropzone,
  Form,
  FormGroup,
  Row,
  Col,
  Input
} from "../../../../components/simple";
import styles from "./locations-builder.module.scss";

const AddZipForRegion = ({ className, onAddZip }) => {
  const [isShowZipModal, setIsShowZipModal] = useState(false);
  const [name, setName] = useState("");
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  const close = () => {
    setName("");
    setFile(null);
    setError("");
    setIsShowZipModal(false);
  };

  const handleFileDrop = val => {
    const fileData = new FormData();
    if (val) {
      fileData.append("postal_code_file", val[0]);
      setFile(fileData);
    } else {
      setFile(null);
    }
  };

  const onSubmit = async e => {
    e.preventDefault();
    if (file === null) {
      return;
    }
    file.set("name", name);
    const res = await onAddZip(file);
    if (res) {
      setError(res);
    } else {
      close();
    }
  };

  return (
    <>
      <button
        type="button"
        className={styles["btn-underline"]}
        onClick={() => setIsShowZipModal(true)}
      >
        Add ZipCode
      </button>

      <ModalView
        isOpen={isShowZipModal}
        toggle={() => {
          setIsShowZipModal(close);
        }}
        changeModalState={close}
        handleClose={close}
      >
        <Form onSubmit={onSubmit} className={`invite-form ${className}`}>
          <h2 className="title">Upload custome region</h2>
          <FormGroup>
            <Row>
              <Col lg={12} md={12} sm={12}>
                <Input
                  type="text"
                  value={name}
                  label="Name region"
                  name="username"
                  placeholder="Name region"
                  required
                  handleChange={(_, v) => setName(v)}
                />
              </Col>
              <Col lg={12} md={12} sm={12}>
                <Dropzone accept=".xlsx, .xls, .csv" onDrop={handleFileDrop} />
              </Col>
            </Row>
            <Row>
              <Col>
                {error && <small className="text-danger">{error}</small>}
              </Col>
            </Row>
          </FormGroup>

          <Button
            type="submit"
            className="button"
            disabled={!file || !name}
            style={{ minWidth: "133px", justifyContent: "center" }}
          >
            Save
          </Button>
        </Form>
      </ModalView>
    </>
  );
};

AddZipForRegion.propTypes = {
  className: PropTypes.string,
  onAddZip: PropTypes.func
};

AddZipForRegion.defaultProps = {
  className: "",
  onAddZip: () => {}
};

export default AddZipForRegion;
